export enum AccountStatus {
  ACTIVE = 'ACTIVE',
  NEW = 'NEW',
  PROSPECT = 'PROSPECT',
}

export const STATUS_OPTIONS = Object.values(AccountStatus);

export interface RestaurantGroup {
  name: string;
  uuid: string;
}

export interface FulfillmentDate {
  display: string;
}

export interface AccountListRowData {
  accountId: string | null;
  lastFulfillmentDate: FulfillmentDate | null;
  restaurantAddress: string;
  restaurantName: string;
  restaurantUUID: string;
  supplierUUID: string;
}

export enum ColumnId {
  LastFulfilled = 'lastFulfilled',
  Name = 'name',
}

export interface AccountListFilterSelection {
  clearFilters: () => void;
  hasActiveFilters: boolean;
  selectedGroups: Set<string>;
  selectedStatuses: Set<AccountStatus>;
  toggleGroup: (uuid: string) => void;
  toggleStatus: (status: AccountStatus) => void;
}
